/** Formal/title style: "M." / "Mme" */
export const GENDER_LABELS_TITLE = new Map<string, string>([
  ['FEMALE', 'Mme'],
  ['MALE', 'M.'],
])

/** Full descriptive style: "Homme" / "Femme" */
export const GENDER_LABELS_FULL = new Map<string, string>([
  ['FEMALE', 'Femme'],
  ['MALE', 'Homme'],
])
